import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import HtmlToReact from 'html-to-react';
import xss from 'xss';
import { showSendConsultNowInvitationModal } from 'actions/modal';
import { useCountdown } from 'businessLogic/helperHooks.js';

const CenterPanelSent = (props) => {
  const dispatch = useDispatch();
  let withoutIcon = 'ui button left-text color-button color-button-hover color-white mrlnull mrbnull mrtm';
  let htmlToReactParser = new HtmlToReact.Parser(React);

  const { start, time, stop, updateCountDown } = useCountdown({
    h: 0,
    m: 0,
    s: props.remainingSeonds === 0 ? 0 : props.remainingSeonds || 300,
    onCompleteCb: () => {
      props.formik.resetForm(props.formik.initialValues);
      props.setSendInvitationExpired(true);
    },
  });

  useEffect(() => {
    if (!!props.remainingSeonds) {
      stop();
      updateCountDown(0, 0, props.remainingSeonds);
      start();
    } else {
      start();
    }
  }, [props.remainingSeonds]);

  const openCall = () => {
    let features = [
      'height=' + (window.screen.height - 100),
      'width=' + (window.screen.width - 20),
      'fullscreen=yes',
    ].join(',');
    window.open(`/ce/?consultNowAuth=${props.currentConsultNowTicketId}`, 'Provider Call Screen', features);
    dispatch(showSendConsultNowInvitationModal(false));
  };

  return (
    <div className="ui form mrbl pdtsss">
      <div className="title-sms mrtm">{APP.LANGUAGE.SendConsultNowInvitation.SentSuccessfulInfo1}</div>

      <div className="title-sms mrtm">
        <span className={`bold ${Number(time.format('m')) < 1 ? 'waiting-area-red' : ''} `}>
          {time.format('mm:ss').split(':')[0]}m{time.format('mm:ss').split(':')[1]}s
        </span>
        <span>{APP.LANGUAGE.SendConsultNowInvitation.SentSuccessfulInfo2}</span>
      </div>
      <div className="title-sms mrtm">
        {htmlToReactParser.parse(xss(APP.LANGUAGE.SendConsultNowInvitation.SentSuccessfulInfo3))}
      </div>
      <button tabIndex="1" type="button" className={withoutIcon + ' no-icon-btn'} onClick={openCall}>
        {APP.LANGUAGE.SendConsultNowInvitation.OpenCall}
      </button>
    </div>
  );
};

export default CenterPanelSent;
